import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Ticket} from "@/modules/redactor/models/currency/Ticket";
import {Currency} from "@/modules/redactor/models/currency/Currency";


export class Money extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(Money, v) : SKIP;
            },
            (v) => {
                return deserialize(Money, v);
            }, {
                beforeDeserialize: function (callback, value) {
                    if (Array.isArray(value)) {
                        callback(null, {"currencies": value});
                    } else {
                        callback(null, value);
                    }
                }
            }
        );
    }

    constructor() {
        super();

        this._tickets = [];
        this._currencies = [];
    }

    get tickets() {
        return this._tickets;
    }

    set tickets(value) {
        this._tickets = value;
    }

    get currencies() {
        return this._currencies;
    }

    set currencies(value) {
        this._currencies = value;
    }

    valid() {

        if (this.tickets && this.tickets.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.currencies && this.currencies.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return (!this.tickets || this.tickets.length === 0) &&
            (!this.currencies || this.currencies.length === 0);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Money());
        } else if (target instanceof Money) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Money, {
    _tickets: alias("tickets", list(Ticket.schema())),
    _currencies: alias("currencies", list(Currency.schema())),
});